// BrandScene — the per-page background branch system.
//
// Replaces the older BrandBranches component, which was hardwired
// to the palm scene. BrandScene is a dispatcher over the scene
// library at ./brandScenes/ — each scene is its own component
// that knows how to render itself for both beige and green
// surfaces, so pages can pick a scene that fits their feel
// (`palms`, `vines`, etc.) without rebuilding the background
// each time.
//
// Usage pattern, matching the per-section architecture both the
// welcome and find pages use:
//
//   <View style={{ position: "relative", overflow: "hidden", backgroundColor: SAND }}>
//     <BrandScene scene="palms" tone="on-beige" />
//     {/* content here paints on top via DOM order */}
//   </View>
//   <View style={{ position: "relative", overflow: "hidden", backgroundColor: FOREST }}>
//     <BrandScene scene="palms" tone="on-green" />
//     {/* content here paints on top via DOM order */}
//   </View>
//
// No z-index or stacking-context tricks needed — the BrandScene
// renders as the first child of a section, so content rendered
// after it naturally paints above the branches.

import { SCENES, type SceneName, type SceneTone } from "./brandScenes";

export type { SceneName, SceneTone };

export function BrandScene({ scene, tone }: { scene: SceneName; tone: SceneTone }) {
  const SceneComponent = SCENES[scene];
  return <SceneComponent tone={tone} />;
}
